/* V19: hydrate optional UI on intent; leave native forms and theme widgets in charge. */
(() => {
  const hydrateCountries = (popover) => {
    const template = popover?.querySelector('template[data-bs-country-options]');
    if (!template) return;
    template.replaceWith(template.content.cloneNode(true));
  };
  // The theme dispatches this before animation, focus trapping and moving the dialog.
  document.addEventListener('dialog:before-show', (event) => hydrateCountries(event.target), true);
  // Support an already open section when Shopify's editor replaces a section.
  const init = (root = document) => {
    root.querySelectorAll('x-popover[open]').forEach(hydrateCountries);
    root.querySelectorAll('video[data-bs-video-poster]').forEach((video) => {
      if (video.dataset.bsPosterObserved) return;
      video.dataset.bsPosterObserved = 'true';
      const loadPoster = () => {
        if (!video.dataset.bsVideoPoster) return;
        const url = new URL(video.dataset.bsVideoPoster, location.href);
        const desired = video.getBoundingClientRect().width * Math.min(devicePixelRatio || 1, 2);
        const width = desired <= 480 ? 480 : desired <= 800 ? 800 : 1200;
        url.searchParams.set('width', String(width));
        video.poster = url.href;
        delete video.dataset.bsVideoPoster;
        observer?.unobserve(video);
      };
      const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) loadPoster();
          }, { rootMargin: '400px' })
        : null;
      if (observer) observer.observe(video); else loadPoster();
      video.addEventListener('pointerdown', loadPoster, { once: true, passive: true });
      video.addEventListener('focus', loadPoster, { once: true });
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

/* Track only Shopify's native banner, without changing consent or region decisions. */
(() => {
  let banner;
  const sync = () => {
    const rect = banner?.getBoundingClientRect();
    const visible = !!(rect?.height && getComputedStyle(banner).display !== 'none' && getComputedStyle(banner).visibility !== 'hidden');
    document.body.classList.toggle('bs-consent-visible', visible);
    if (visible) document.documentElement.style.setProperty('--bs-consent-clearance', Math.ceil(innerHeight - rect.top + 12) + 'px');
    else document.documentElement.style.removeProperty('--bs-consent-clearance');
  };
  const size = 'ResizeObserver' in window ? new ResizeObserver(sync) : null;
  const attrs = new MutationObserver(sync);
  const connect = () => {
    const next = document.getElementById('shopify-pc__banner');
    if (next === banner) return;
    size?.disconnect(); attrs.disconnect(); banner = next;
    if (banner) {
      size?.observe(banner);
      attrs.observe(banner, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
    sync();
  };
  // Shopify inserts/removes its banner directly under body.
  new MutationObserver(connect).observe(document.body, { childList: true });
  window.addEventListener('resize', sync, { passive: true });
  connect();
})();
